import {
  AUTH_REQUEST, AUTH_LOGOUT,
  AUTH_SUCCESS, AUTH_ERROR
} from './types'

const BASE_URL = process.env.VUE_APP_API_AUTH

// Libs 
import axios from 'axios'

export const login = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    commit(AUTH_REQUEST)
    axios({
      url: `${BASE_URL}/user/login`,
      data: payload,
      withCredentials: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then (response => {
      const token = response.data.token
      const user = (response.data.user)

      // console.log(response.headers)
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('csrf_token', token)
      localStorage.setItem('accept_language', user.language.toLowerCase())
      axios.defaults.headers.common['Authentication'] = `${response.data.session_name}=${response.data.sessid}`
      axios.defaults.headers.common['X-CSRF-Token'] = token
      axios.defaults.headers.common['Accept-Language'] = user.language.toLowerCase()
      // document.cookie = `${response.data.session_name}=${response.data.sessid}`
      
      commit(AUTH_SUCCESS, { token, user })
      resolve(response)
    })
    .catch (error => {
      console.log({
        name: error.name,
        message: error.message,
      })
      commit(AUTH_ERROR, {
        name: error.name,
        message: error.message,
      })
      localStorage.removeItem('user')
      localStorage.removeItem('csrf_token')
      localStorage.removeItem('accept_language')
      delete axios.defaults.headers.common['Authentication']
      delete axios.defaults.headers.common['X-CSRF-Token']
      reject(error)
    })
  })
}

export const sessionAuth = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit(AUTH_REQUEST)
    const token = localStorage.getItem('csrf_token')
    if (token !== null) {
      axios.defaults.headers.common['X-CSRF-Token'] = token
    }
    axios({
      url: `${BASE_URL}/system/connect`,
      data: {},
      withCredentials: "include",
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then (response => {
      const session = response.data
      axios.defaults.headers.common['Authentication'] = `${session.session_name}=${session.sessid}`
      if (session.user.uid !== 0) {
        const user = (session.user)
        axios.defaults.headers.common['Accept-Language'] = session.user.language.toLowerCase()
        commit(AUTH_SUCCESS, { token, user })
      }
      else {

        const user = (session.user)
        const token = (session.token)
        localStorage.removeItem('user')
        localStorage.removeItem('csrf_token')
        localStorage.removeItem('accept_language')
        delete axios.defaults.headers.common['Authentication']
        delete axios.defaults.headers.common['X-CSRF-Token']

        // console.log(response.headers)
        // localStorage.setItem('user', JSON.stringify(response.data.user))
        localStorage.setItem('csrf_token', token)
        // localStorage.setItem('accept_language', user.language.toLowerCase())
        axios.defaults.headers.common['Authentication'] = `${session.session_name}=${session.sessid}`
        axios.defaults.headers.common['X-CSRF-Token'] = token
        // axios.defaults.headers.common['Accept-Language'] = user.language.toLowerCase()
      
        commit(AUTH_SUCCESS, { token, user })
      }
      resolve(response)
    })
      .catch (error => {
        console.log({
          name: error.name,
          message: error.message,
        })
        commit(AUTH_ERROR, {
          name: error.name,
          message: error.message,
        })
        localStorage.removeItem('user')
        localStorage.removeItem('csrf_token')
        localStorage.removeItem('accept_language')
        delete axios.defaults.headers.common['Authentication']
        delete axios.defaults.headers.common['X-CSRF-Token']
        reject(error)
      })
  })   
}

export const refreshToken = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit(AUTH_REQUEST)
    axios({
      url: `${BASE_URL}/user/token`,
      data: {},
      withCredentials: "include",
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then (response => {
      const token = localStorage.getItem('csrf_token')
      if (response.data.token !== token) {
        localStorage.setItem('csrf_token', response.data.token)
        axios.defaults.headers.common['X-CSRF-Token'] = response.data.token
      }
      resolve(response)
    })
      .catch (error => {
        console.log({
          name: error.name,
          message: error.message,
        })
        commit(AUTH_ERROR, {
          name: error.name,
          message: error.message,
        })
        localStorage.removeItem('user')
        localStorage.removeItem('csrf_token')
        localStorage.removeItem('accept_language')
        delete axios.defaults.headers.common['Authentication']
        delete axios.defaults.headers.common['X-CSRF-Token']
        reject(error)
      })
  })
}

export const logout = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit(AUTH_REQUEST)
    axios({
      url: `${BASE_URL}/user/logout`,
      withCredentials: "include",
      data: {},
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then (response => {
        // console.log(response.headers)
        localStorage.removeItem('user')
        localStorage.removeItem('csrf_token')
        localStorage.removeItem('accept_language')
        delete axios.defaults.headers.common['Authentication']
        delete axios.defaults.headers.common['X-CSRF-Token']
        commit(AUTH_LOGOUT)
        // if (response.data[0] === true) {
          resolve(response)
        // }
      })
      .catch (error => {
        commit(AUTH_ERROR, {
          name: error.name,
          message: error.message,
        })
        localStorage.removeItem('user')
        localStorage.removeItem('csrf_token')
        localStorage.removeItem('accept_language')
        delete axios.defaults.headers.common['Authentication']
        delete axios.defaults.headers.common['X-CSRF-Token']
        reject(error)
      })
  })
}
